import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  CreateUserValueOfPurchasePointCommand,
  Range,
  UpdateUserValueOfPurchasePointCommand,
  UserValueOfPurchasePointModel,
} from 'src/app/core/api/models';
import { UserValueOfPurchasesPointsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  BaseFormModule,
  BaseFormPageComponent,
} from 'src/app/pages/shared/base';

@Component({
  selector: 'app-value-of-purchase-points-form',
  styleUrls: ['./value-of-purchase-points-form.component.scss'],
  templateUrl: './value-of-purchase-points-form.component.html',
  imports: [BaseFormModule],
})
export class ValueOfPurchasePointsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() model: CreateUserValueOfPurchasePointCommand = {};
  sizeRanges: Range[] = [];

  //#endregion

  constructor(
    protected currentService: UserValueOfPurchasesPointsService,
    protected renderer: Renderer2
  ) {
    super();
  }

  //#region init methods
  ngOnInit(): void {
    this.getVocabs();
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.initModel();
  }

  initModel() {
    super.initModel();
    this.onAddSizeRange(0, 0);

    if (this.formPageConfig.editData.ranges?.length > 0)
      this.setGroupPriceDetail(this.formPageConfig.editData.ranges);
  }

  setGroupPriceDetail(model: Range[]) {
    try {
      if (model.length) this.sizeRanges = [];
      model.forEach((item) => {
        let sizeRange = this.sizeRanges.find(
          (range) => range.valueStartRange == item.valueStartRange
        );
        //add
        if (!sizeRange) {
          this.onAddSizeRange(
            item.valueStartRange,
            item.valueEndRange,
            item.point
          );
          sizeRange = this.sizeRanges.find(
            (range) => range.valueStartRange == item.valueStartRange
          );
        }
        // update
        // sizeRange.priceList = sizeRange?.priceList.map((priceItem) =>
        //   priceItem.smsAggregator == item.smsAggregator
        //     ? { smsAggregator: item.smsAggregator, price: item.price || null }
        //     : priceItem
        // );
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      index: new FormControl(''),
      point: new FormControl(''),
      valueStartRange: new FormControl(''),
      valueEndRange: new FormControl(''),
    });
  }

  fillColumn(smsAggregatorInput, event?) {
    try {
      if (event) if (event?.key !== 'Enter' && event?.type != 'change') return;

      const value = +(smsAggregatorInput as HTMLInputElement).value;

      //get input elements and set value
      let inputs = this.getInputs();
      inputs.forEach((input) => {
        this.renderer.setProperty(
          <HTMLInputElement>input,
          'value',
          value.toString()
        );

        (<HTMLInputElement>input).removeAttribute('style');
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getInputs(): Element[] {
    try {
      const inputElements: NodeListOf<Element> = document.querySelectorAll(
        `${this.tagName} .input-item`
      );
      return Array.from(inputElements);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onAddSizeRange(valueStartRange?: number, valueEndRange?: any, point?: any) {
    // let smsAggregators: number[] = this.SmsAggregatorValues.filter(
    //   (item) => +item.value != 0
    // ).map((item) => +item.value);

    const newSizeRange: Range = {};
    // newSizeRange.priceList = smsAggregators.map((smsAggregator) => ({
    //   smsAggregator,
    //   price: null,
    // }));

    if (valueStartRange || valueStartRange == 0)
      newSizeRange.valueStartRange = valueStartRange;

    if (valueEndRange) {
      newSizeRange.valueEndRange = valueEndRange;
    }

    if (point) {
      newSizeRange.point = point;
    }

    this.sizeRanges.push(newSizeRange);
  }

  onUpdateSizeRange(beginningInput, endInput, index) {
    const valueStartRange = +(beginningInput as HTMLInputElement)?.value;
    const valueEndRange = +(endInput as HTMLInputElement)?.value;

    // if (valueStartRange > valueEndRange) {
    //   //if (!valueStartRange || !valueEndRange) return;
    //   this.addInputError(beginningInput, endInput);
    // } else {
    //   this.removeInputError(beginningInput, endInput);
    // }
    if (valueStartRange >= 0)
      this.sizeRanges[index].valueStartRange = valueStartRange;
    if (valueEndRange >= 0)
      this.sizeRanges[index].valueEndRange = valueEndRange;
  }

  setInfinite(beginningInput, endInput, valueEndRangeIndex) {
    if (this.sizeRanges[valueEndRangeIndex])
      this.sizeRanges[valueEndRangeIndex].valueEndRange = -1;
    // this.addInputError(beginningInput, endInput);
    // this.removeInputError(beginningInput, endInput);
  }

  onRemoveSizeRange(index) {
    if (index < this.sizeRanges?.length) this.sizeRanges.splice(index, 1);
  }

  isEmptyInput(event) {
    try {
      if (!event.target.value) {
        (<HTMLInputElement>event.target).style.cssText = `
        background-color:#fae7e7;
        `;
      } else {
        (<HTMLInputElement>event.target).removeAttribute('style');
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //#endregion

  //#region Api
  //Create
  baseCreateApi(model: CreateUserValueOfPurchasePointCommand) {
    this.loading = true;

    this.currentService
      .userValueOfPurchasesPointsCreate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateUserValueOfPurchasePointCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .userValueOfPurchasesPointsUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
  getGroupPriceDetail(): UserValueOfPurchasePointModel {
    try {
      const inputs: Element[] = this.getInputs();

      let finalModel: UserValueOfPurchasePointModel = {};
      finalModel.index = this.model.index;
      finalModel.ranges = [];
      inputs.forEach((item: Element) => {
        let range = {
          point: +(<HTMLInputElement>item).value,
          valueStartRange: +(<HTMLInputElement>item).dataset.valuestartrange,
          valueEndRange:
            (<HTMLInputElement>item).dataset.valueendrange == '∞'
              ? -1
              : +(<HTMLInputElement>item).dataset.valueendrange,
        };
        finalModel.ranges.push(range);
      });

      return finalModel;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.model = this.getGroupPriceDetail();

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
